import { Flex } from '@applyboard/crystal-ui';

import { GradeConversionDetailsHeading } from '../components/GradeConversionDetailsHeading';
import { GradeConversionInformation } from '../components/GradeConversionInformation';
import { GradeConversionLayoutProps } from './types';

export function DesktopLayout(props: GradeConversionLayoutProps) {
  const { conversionTable, gradeSchema, gradePointMappings, educationLevels, countries } = props;

  return (
    <Flex p={10} gap={8} direction="column">
      <GradeConversionDetailsHeading />
      <GradeConversionInformation
        conversionTable={conversionTable}
        gradeSchema={gradeSchema}
        gradePointMappings={gradePointMappings}
        educationLevels={educationLevels}
        countries={countries}
      />
    </Flex>
  );
}
